<template>
    <div class="yiqi-login">
        <!-- 弥散光晕 -->
        <div class="yiqi-login__blobs" aria-hidden="true">
            <span class="yiqi-blob yiqi-blob--a"></span>
            <span class="yiqi-blob yiqi-blob--b"></span>
            <span class="yiqi-blob yiqi-blob--c"></span>
        </div>

        <!-- 粒子网 -->
        <canvas ref="bgCanvas" class="yiqi-login__canvas" aria-hidden="true"></canvas>

        <main class="yiqi-card">
            <!-- 左侧品牌：插画底（内嵌立体Logo光球）+ 品牌标语与服务保障。最后更新：2026-10-30 -->
            <section class="yiqi-brand" aria-label="一柒智校品牌区">
                <div class="yiqi-brand__bg" aria-hidden="true"></div>
                <div class="yiqi-brand__content">
                    <!-- 顶部占位，留出背景图中光球与Logo展示空间 -->
                    <div class="yiqi-brand__orb-space" aria-hidden="true"></div>
                    <div class="yiqi-brand__hero">
                        <h2 class="yiqi-brand__title">以数字枢纽<br>构智慧校园</h2>
                        <p class="yiqi-brand__slogan">一数汇全域，智育启新程</p>
                        <p class="yiqi-brand__desc">
                            汇聚校园数据，打通应用链路，<br>以数字赋能育人，打造高效智慧校园。
                        </p>
                        <div class="yiqi-brand__badges" aria-label="服务保障">
                            <span class="yiqi-brand__badge">
                                <i class="el-icon-check" aria-hidden="true"></i>
                                <span>稳定服务在线</span>
                            </span>
                            <span class="yiqi-brand__badge">
                                <i class="el-icon-check" aria-hidden="true"></i>
                                <span>SSL 加密护航</span>
                            </span>
                        </div>
                    </div>
                </div>
            </section>

            <!-- 右侧表单 -->
            <section class="yiqi-panel">
                <div class="yiqi-panel__inner">
                    <!-- 登录视图 -->
                    <div v-show="panelMode === 'login'" class="yiqi-panel__view">
                        <header class="yiqi-panel__head">
                            <h1>管理人员登录</h1>
                            <p>{{ loginMode === 'sms' ? '使用绑定的安全手机号登录管理系统' : '智慧校园运营管理控制台，请核验管理权限' }}</p>
                        </header>

                        <div v-if="smsLoginEnabled" class="yiqi-login-tabs" role="tablist">
                            <button type="button" role="tab" :aria-selected="loginMode === 'account' ? 'true' : 'false'"
                                :class="{ active: loginMode === 'account' }" @click="switchLoginMode('account')">
                                <i class="el-icon-user" aria-hidden="true"></i>
                                <span>管理员账号登录</span>
                            </button>
                            <button type="button" role="tab" :aria-selected="loginMode === 'sms' ? 'true' : 'false'"
                                :class="{ active: loginMode === 'sms' }" @click="switchLoginMode('sms')">
                                <i class="el-icon-mobile-phone" aria-hidden="true"></i>
                                <span>安全手机登录</span>
                            </button>
                        </div>

                        <el-form :model="ruleForm2" :rules="activeLoginRules" ref="ruleForm2" label-position="top"
                            class="yiqi-form" :class="{ 'is-sms': loginMode === 'sms' }"
                            @submit.native.prevent="handleSubmit2">
                            <template v-if="loginMode === 'account'">
                                <el-form-item prop="account" label="管理员账号">
                                    <el-input type="text" v-model="ruleForm2.account" auto-complete="username"
                                        placeholder="请输入管理员账号" prefix-icon="el-icon-user" class="yiqi-input"
                                        @blur.native="persistRememberAccount"
                                        @keyup.enter.native="handleSubmit2"></el-input>
                                </el-form-item>

                                <el-form-item prop="checkPass">
                                    <div slot="label" class="yiqi-form__pwd-label">
                                        <span>登录密码</span>
                                        <a href="javascript:;" class="yiqi-form__forgot"
                                            @click.prevent="openResetPasswordView">忘记密码？</a>
                                    </div>
                                    <el-input v-model="ruleForm2.checkPass" auto-complete="current-password"
                                        show-password placeholder="请输入管理员登录密码" prefix-icon="el-icon-lock"
                                        class="yiqi-input" @keyup.enter.native="handleSubmit2"></el-input>
                                </el-form-item>

                                <div class="yiqi-form__remember">
                                    <el-checkbox v-model="rememberMe" @change="onRememberChange">记住管理员账号</el-checkbox>
                                </div>

                                <el-form-item class="yiqi-form__action">
                                    <el-button type="primary" class="yiqi-form__submit" :loading="logining"
                                        :disabled="logining" @click.native.prevent="handleSubmit2">
                                        {{ loginStr === '登 录' ? '立即进入控制台' : loginStr }}
                                    </el-button>
                                </el-form-item>
                            </template>

                            <template v-else>
                                <el-form-item prop="mobilePhone" label="绑定的安全手机号">
                                    <el-input v-model="ruleForm2.mobilePhone" maxlength="11" placeholder="请输入绑定的11位手机号"
                                        prefix-icon="el-icon-mobile-phone" class="yiqi-input" @input="sanitizeSmsPhone"
                                        @keyup.enter.native="handleSubmit2"></el-input>
                                </el-form-item>
                                <el-form-item prop="code" label="短信验证码">
                                    <div class="yiqi-sms-code">
                                        <el-input v-model="ruleForm2.code" maxlength="6" placeholder="请输入6位验证码"
                                            prefix-icon="el-icon-message" class="yiqi-input" @input="sanitizeSmsCode"
                                            @keyup.enter.native="handleSubmit2"></el-input>
                                        <el-button native-type="button" class="yiqi-sms-code__button"
                                            :loading="smsSending" :disabled="smsCountdown > 0" @click="sendSmsCode">{{
                                                smsCountdown > 0 ? `${smsCountdown}s 后重发` : '获取验证码' }}</el-button>
                                    </div>
                                </el-form-item>
                                <!-- 与账号登录「记住账号」行等高，避免 Tab 切换时面板高度跳动 -->
                                <div class="yiqi-form__remember yiqi-form__remember--spacer" aria-hidden="true"></div>
                                <el-form-item class="yiqi-form__action">
                                    <el-button type="primary" class="yiqi-form__submit" :loading="logining"
                                        :disabled="logining" @click.native.prevent="handleSubmit2">{{ loginStr === '登 录'
                                            ? '立即进入控制台' : loginStr }}</el-button>
                                </el-form-item>
                            </template>
                        </el-form>
                    </div>

                    <!-- 重置密码视图：对齐 docs/后台账号/登陆页面.html -->
                    <div v-show="panelMode === 'reset'" class="yiqi-panel__view yiqi-reset-view">
                        <header class="yiqi-panel__head">
                            <button type="button" class="yiqi-reset-back" @click="closeResetPasswordView">
                                <i class="el-icon-arrow-left" aria-hidden="true"></i>
                                <span>返回登录</span>
                            </button>
                            <h1>重置管理员密码</h1>
                            <p>验证绑定的安全手机后即可设置新密码</p>
                        </header>

                        <el-form :model="resetForm" :rules="resetRules" ref="resetForm" label-position="top"
                            class="yiqi-form yiqi-reset-form" @submit.native.prevent="submitResetPassword">
                            <el-form-item prop="mobilePhone" label="安全手机号">
                                <el-input v-model="resetForm.mobilePhone" maxlength="11" placeholder="请输入手机号"
                                    prefix-icon="el-icon-mobile-phone" class="yiqi-input" @input="sanitizeResetPhone"
                                    @keyup.enter.native="submitResetPassword"></el-input>
                            </el-form-item>
                            <el-form-item prop="code" label="短信验证码">
                                <div class="yiqi-sms-code">
                                    <el-input v-model="resetForm.code" maxlength="6" placeholder="请输入6位验证码"
                                        prefix-icon="el-icon-message" class="yiqi-input" @input="sanitizeResetCode"
                                        @keyup.enter.native="submitResetPassword"></el-input>
                                    <el-button native-type="button" class="yiqi-sms-code__button"
                                        :loading="resetSending" :disabled="resetCountdown > 0" @click="sendResetCode">{{
                                            resetCountdown > 0 ?
                                                `${resetCountdown}秒重新获取` : '获取验证码' }}</el-button>
                                </div>
                            </el-form-item>
                            <el-form-item prop="newPassword" label="新密码">
                                <el-input v-model="resetForm.newPassword" show-password maxlength="20"
                                    placeholder="8-20位字符，包含字母与数字" prefix-icon="el-icon-lock" class="yiqi-input"
                                    @keyup.enter.native="submitResetPassword"></el-input>
                            </el-form-item>
                            <p v-if="resetFeedback" class="yiqi-reset-feedback" :class="resetFeedbackType">{{
                                resetFeedback }}</p>
                            <el-form-item class="yiqi-form__action">
                                <el-button type="primary" class="yiqi-form__submit" :loading="resetSaving"
                                    :disabled="resetSaving"
                                    @click.native.prevent="submitResetPassword">确认修改并返回登录</el-button>
                            </el-form-item>
                        </el-form>
                    </div>

                    <footer class="yiqi-panel__foot">
                        <p>登录即代表同意遵守《系统内部安全管理规定》</p>
                        <p>一柒智校 信息化管理中心 版权所有 · 安全审计已启用</p>
                    </footer>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import {
    requestLogin,
    requestLoginMock,
    getUserByToken,
    getSmsLoginOptions,
    sendSmsLoginCode,
    requestSmsLogin,
    sendSmsResetPasswordCode,
    requestResetPasswordBySms,
} from '../api/modules/auth';
import { getNavigationBar } from '../api/modules/system';
import { clearDeptTreeCache } from '../api/modules/department';
import { fetchAndApplyUserLayout } from '../utils/layoutMode';

import router from '@/router'
import { resetRouter, filterAsyncRouter } from '@/router/index'

const REMEMBER_KEY = 'yiqiLoginRemember';

export default {
    data() {
        return {
            instance: "",
            loginStr: '登 录',
            logining: false,
            loginingMock: false,
            loginMode: 'account',
            panelMode: 'login',
            smsLoginEnabled: false,
            passwordResetEnabled: false,
            smsSending: false,
            smsCountdown: 0,
            smsCountdownTimer: null,
            resetSending: false,
            resetSaving: false,
            resetCountdown: 0,
            resetCountdownTimer: null,
            resetFeedback: '',
            resetFeedbackType: 'success',
            resetForm: {
                mobilePhone: '',
                code: '',
                newPassword: '',
            },
            smsForm: {
                mobilePhone: '',
                code: '',
            },
            rememberMe: false,
            ruleForm2: {
                account: '',
                checkPass: '',
                mobilePhone: '',
                code: ''
            },
            account3: '测试账号1',
            skip: false,
            // 粒子背景
            particleAnimId: 0,
            particles: [],
            particleMouse: { x: null, y: null, radius: 120 },
            particleResizeTimer: null,
            isTouchDevice: false,
        };
    },

    computed: {
        /**
         * 按当前登录方式只启用对应校验，避免账号/手机号规则串场。创建于 2026-10-29
         */
        activeLoginRules() {
            if (this.loginMode === 'sms') {
                return {
                    mobilePhone: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入合规的 11 位手机号', trigger: 'blur' },
                    ],
                    code: [
                        { required: true, message: '请输入短信验证码', trigger: 'blur' },
                        { pattern: /^\d{6}$/, message: '请输入 6 位数字验证码', trigger: 'blur' },
                    ],
                };
            }
            return {
                account: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                ],
                checkPass: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
            };
        },
        /**
         * 重置密码表单校验。创建于 2026-10-29
         */
        resetRules() {
            const validateNewPassword = (rule, value, callback) => {
                const pwd = String(value || '').trim();
                if (!pwd) {
                    callback(new Error('请输入新密码'));
                    return;
                }
                if (pwd.length < 8 || pwd.length > 20 || !/[A-Za-z]/.test(pwd) || !/\d/.test(pwd)) {
                    callback(new Error('新密码需为 8-20 位，且同时包含字母与数字'));
                    return;
                }
                callback();
            };
            return {
                mobilePhone: [
                    { required: true, message: '请输入合规的11位安全手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入合规的11位安全手机号', trigger: 'blur' },
                ],
                code: [
                    { required: true, message: '请输入短信验证码', trigger: 'blur' },
                    { pattern: /^\d{6}$/, message: '请输入 6 位数字验证码', trigger: 'blur' },
                ],
                newPassword: [
                    { validator: validateNewPassword, trigger: 'blur' },
                ],
            };
        },
    },

    methods: {
        /**
         * 「记住我」勾选变化：立即写入/清除本地账号。最后更新：2026-03-29
         */
        onRememberChange(checked) {
            this.rememberMe = !!checked;
            this.persistRememberAccount();
        },
        /**
         * 持久化记住的账号（不存密码）。最后更新：2026-03-29
         */
        persistRememberAccount() {
            try {
                const account = (this.ruleForm2.account || '').trim();
                if (this.rememberMe && account) {
                    window.localStorage.setItem(REMEMBER_KEY, JSON.stringify({ account: account }));
                } else if (!this.rememberMe) {
                    window.localStorage.removeItem(REMEMBER_KEY);
                }
            } catch (e) { /* ignore */ }
        },
        /**
         * 从本地恢复记住的账号。最后更新：2026-03-29
         */
        restoreRememberAccount() {
            try {
                const raw = window.localStorage.getItem(REMEMBER_KEY);
                if (!raw) {
                    return;
                }
                const saved = JSON.parse(raw);
                if (saved && saved.account) {
                    this.ruleForm2.account = saved.account;
                    this.rememberMe = true;
                }
            } catch (e) { /* ignore */ }
        },
        handleReset2() {
            this.$refs.ruleForm2.resetFields();
        },
        loginAccount() {
            if (this.account3 == "测试账号1") {
                this.ruleForm2.account = "test";
                this.ruleForm2.checkPass = "test";
            } else if (this.account3 == "测试账号2") {
                this.ruleForm2.account = "test2";
                this.ruleForm2.checkPass = "test2";
            } else {
                this.ruleForm2.account = "blogadmin";
                this.ruleForm2.checkPass = "blogadmin";
            }
        },
        handleSubmitMock(ev) {
            var _this = this;
            this.$refs.ruleForm2.validate((valid) => {
                if (valid) {
                    this.loginingMock = true;
                    var loginParams = { username: this.ruleForm2.account, password: this.ruleForm2.checkPass };
                    requestLoginMock(loginParams).then(data => {
                        this.loginingMock = false;
                        if (data && data.code && data.msg) {
                            _this.$message({
                                message: data.code + data.msg + "，用户名admin,密码123456",
                                type: 'error'
                            });
                        } else {
                            _this.$message({
                                message: "测试mock，请在main.js 中开启服务!",
                                type: 'error'
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        openAlert(msg) {
            this.instance = this.$notify({
                title: '提示',
                message: msg,
                duration: 0,
                position: 'top-left'
            });
        },
        closeAlert() {
            this.instance.close()
        },
        /**
         * 切换账号密码与手机号登录方式。最后更新：2026-10-29
         */
        switchLoginMode(mode) {
            if (this.loginMode === mode) return;
            this.loginMode = mode;
            this.loginStr = '登 录';
            this.$nextTick(() => {
                if (this.$refs.ruleForm2) this.$refs.ruleForm2.clearValidate();
            });
        },
        /**
         * 打开忘记密码重置面板。创建于 2026-10-29
         */
        openResetPasswordView() {
            if (!this.passwordResetEnabled) {
                this.$message({
                    type: 'info',
                    message: '当前未启用短信重置，请联系各校区系统管理员重置密码',
                    duration: 4000,
                });
                return;
            }
            this.panelMode = 'reset';
            this.resetFeedback = '';
            this.resetForm = {
                mobilePhone: this.ruleForm2.mobilePhone || '',
                code: '',
                newPassword: '',
            };
            this.$nextTick(() => {
                if (this.$refs.resetForm) this.$refs.resetForm.clearValidate();
            });
        },
        /**
         * 返回登录面板。创建于 2026-10-29
         */
        closeResetPasswordView() {
            this.panelMode = 'login';
            this.resetFeedback = '';
            this.resetSaving = false;
        },
        sanitizeSmsPhone(value) {
            this.ruleForm2.mobilePhone = String(value || '').replace(/\D/g, '').slice(0, 11);
        },
        sanitizeSmsCode(value) {
            this.ruleForm2.code = String(value || '').replace(/\D/g, '').slice(0, 6);
        },
        sanitizeResetPhone(value) {
            this.resetForm.mobilePhone = String(value || '').replace(/\D/g, '').slice(0, 11);
        },
        sanitizeResetCode(value) {
            this.resetForm.code = String(value || '').replace(/\D/g, '').slice(0, 6);
        },
        /**
         * 发送重置密码验证码。创建于 2026-10-29
         */
        sendResetCode() {
            if (this.resetSending || this.resetCountdown > 0) return;
            this.$refs.resetForm.validateField('mobilePhone', (error) => {
                if (error) return;
                this.resetSending = true;
                this.resetFeedback = '';
                sendSmsResetPasswordCode({ mobilePhone: this.resetForm.mobilePhone }).then((data) => {
                    if (!data || !data.success) {
                        this.resetFeedbackType = 'error';
                        this.resetFeedback = (data && data.msg) || '验证码发送失败';
                        return;
                    }
                    this.resetFeedbackType = 'success';
                    this.resetFeedback = (data && data.msg) || '重置验证码已发送，请查收';
                    this.resetCountdown = 60;
                    if (this.resetCountdownTimer) clearInterval(this.resetCountdownTimer);
                    this.resetCountdownTimer = setInterval(() => {
                        if (this.resetCountdown <= 1) {
                            clearInterval(this.resetCountdownTimer);
                            this.resetCountdownTimer = null;
                            this.resetCountdown = 0;
                        } else {
                            this.resetCountdown -= 1;
                        }
                    }, 1000);
                }).catch(() => {
                    this.resetFeedbackType = 'error';
                    this.resetFeedback = '验证码发送失败，请稍后重试';
                }).finally(() => {
                    this.resetSending = false;
                });
            });
        },
        /**
         * 提交手机号验证码重置密码。创建于 2026-10-29
         */
        submitResetPassword() {
            if (this.resetSaving) return;
            this.$refs.resetForm.validate((valid) => {
                if (!valid) return;
                this.resetSaving = true;
                this.resetFeedback = '';
                requestResetPasswordBySms({
                    mobilePhone: this.resetForm.mobilePhone,
                    code: this.resetForm.code,
                    newPassword: this.resetForm.newPassword,
                }).then((data) => {
                    if (!data || !data.success) {
                        this.resetFeedbackType = 'error';
                        this.resetFeedback = (data && data.msg) || '密码重置失败';
                        this.resetSaving = false;
                        return;
                    }
                    this.resetFeedbackType = 'success';
                    this.resetFeedback = '密码已成功重置！2秒后自动返回登录...';
                    const loginName = data.response && data.response.loginName;
                    if (loginName) this.ruleForm2.account = loginName;
                    this.ruleForm2.checkPass = '';
                    setTimeout(() => {
                        this.closeResetPasswordView();
                        this.resetSaving = false;
                    }, 2000);
                }).catch(() => {
                    this.resetFeedbackType = 'error';
                    this.resetFeedback = '密码重置失败，请稍后重试';
                    this.resetSaving = false;
                });
            });
        },
        /**
         * 发送后台手机号登录验证码。
         */
        sendSmsCode() {
            if (this.smsSending || this.smsCountdown > 0) return;
            this.$refs.ruleForm2.validateField('mobilePhone', (error) => {
                if (error) return;
                this.smsSending = true;
                sendSmsLoginCode({ mobilePhone: this.ruleForm2.mobilePhone }).then((data) => {
                    if (!data || !data.success) {
                        this.$message.error((data && data.msg) || '验证码发送失败');
                        return;
                    }
                    this.smsCountdown = 60;
                    this.smsCountdownTimer = setInterval(() => {
                        if (this.smsCountdown <= 1) {
                            clearInterval(this.smsCountdownTimer);
                            this.smsCountdownTimer = null;
                            this.smsCountdown = 0;
                        } else {
                            this.smsCountdown -= 1;
                        }
                    }, 1000);
                    this.$message.success('验证码已发送，请查收短信');
                }).catch(() => {
                    this.$message.error('验证码发送失败，请稍后重试');
                }).finally(() => {
                    this.smsSending = false;
                });
            });
        },
        /**
         * 使用手机号验证码登录，并复用现有登录成功后的初始化流程。
         */
        handleSmsSubmit() {
            this.$refs.ruleForm2.validate((valid) => {
                if (!valid) return;
                this.logining = true;
                this.loginStr = '登录中...';
                requestSmsLogin({
                    mobilePhone: this.ruleForm2.mobilePhone,
                    code: this.ruleForm2.code,
                }).then((data) => {
                    if (!data || !data.success) {
                        this.$message.error((data && data.msg) || '登录失败');
                        this.logining = false;
                        this.loginStr = '重新登录';
                        return;
                    }
                    this.loginStr = '成功获取Token，等待服务器返回用户信息...';
                    this.saveTokenAndInitialize(data.response.token, data.response.expires_in);
                }).catch(() => {
                    this.logining = false;
                    this.loginStr = '重新登录';
                });
            });
        },
        saveTokenAndInitialize(token, expiresIn) {
            this.$store.commit('saveToken', token);
            const expiredate = new Date(Date.now() + Number(expiresIn) * 1000);
            this.$store.commit('saveTokenExpire', expiredate.toISOString());
            window.localStorage.refreshtime = new Date(expiredate.getTime() + 10 * 60 * 1000).toISOString();
            window.localStorage.expires_in = expiresIn;
            this.getUserInfoByToken(token);
        },
        handleSubmit2(ev) {
            if (this.loginMode === 'sms') {
                this.handleSmsSubmit();
                return;
            }
            var _this = this;
            if (this.logining) {
                return;
            }
            this.logining = true;
            this.loginStr = "登录中...";

            this.$refs.ruleForm2.validate((valid) => {
                if (valid) {
                    this.persistRememberAccount();

                    var loginParams = { name: this.ruleForm2.account, pass: this.ruleForm2.checkPass };
                    requestLogin(loginParams).then(data => {
                        if (!data.success) {
                            _this.$message({
                                message: data.msg,
                                type: 'error'
                            });
                            _this.logining = false;
                            _this.loginStr = "重新登录";
                        } else {
                            var token = data.response.token;
                            _this.$store.commit("saveToken", token);
                            var expiredate = new Date(Date.now() + Number(data.response.expires_in) * 1000);
                            var expireIso = expiredate.toISOString();
                            _this.$store.commit("saveTokenExpire", expireIso);
                            var refreshUntil = new Date(expiredate.getTime());
                            refreshUntil.setMinutes(refreshUntil.getMinutes() + 10);
                            window.localStorage.refreshtime = refreshUntil.toISOString();
                            window.localStorage.expires_in = data.response.expires_in;
                            _this.$notify({
                                type: "success",
                                message: `成功获取令牌，项目初始化中...`,
                                duration: 3000
                            });
                            _this.loginStr = "成功获取Token，等待服务器返回用户信息...";
                            _this.getUserInfoByToken(token)
                        }
                    }).catch(e => {
                        _this.logining = false;
                        _this.loginStr = "重新登录";
                    });
                } else {
                    _this.logining = false;
                    _this.loginStr = "登 录";
                    return false;
                }
            });
        },
        getUserInfoByToken(token) {
            var _this = this;
            var loginParams = { token: token };
            getUserByToken(loginParams).then(data => {
                if (!data.success) {
                    _this.$message({
                        message: data.msg,
                        type: 'error'
                    });
                    _this.logining = false;
                    _this.loginStr = "重新登录";
                } else {
                    _this.loginStr = "接收到用户数据，开始初始化路由树...";
                    window.localStorage.user = JSON.stringify(data.response)
                    this.$store.commit('setDepartmentName', data.response.DepartmentName)
                    if (data.response.uID > 0) {
                        fetchAndApplyUserLayout(data.response.uID, _this.$store).finally(() => {
                            _this.GetNavigationBar(data.response.uID)
                        })
                    } else {
                        _this.logining = false;
                        _this.loginStr = "重新登录";
                    }
                }
            }).catch(() => {
                _this.logining = false;
                _this.loginStr = "重新登录";
            });
        },
        GetNavigationBar(uid) {
            var _this = this;
            var loginParams = { uid: uid, t: new Date() };
            _this.loginStr = "接收到用户数据，开始初始化路由树...";
            getNavigationBar(loginParams).then(data => {
                if (!data.success) {
                    _this.logining = false;
                    _this.loginStr = "重新登录";
                    _this.$message({
                        message: data.msg,
                        type: 'error'
                    });
                    return;
                }
                _this.loginStr = "初始化完成，正在进入系统...";
                _this.$message({
                    message: "后台初始化成功",
                    type: 'success'
                });
                let userinfo = JSON.parse(window.localStorage.user ? window.localStorage.user : null);
                _this.$notify({
                    type: "success",
                    message: `登录成功 \n 欢迎管理员：${userinfo.uRealName} ！Token 将在 ${window.localStorage.expires_in / 60} 分钟后过期！`,
                    duration: 6000
                });
                window.localStorage.router = (JSON.stringify(data.response.children));
                let getRouter = data.response.children
                getRouter = filterAsyncRouter(getRouter)
                router.$addRoutes(getRouter)
                _this.$root.$emit('user-logged-in');
                _this.$router.replace(_this.$route.query.redirect ? _this.$route.query.redirect : "/");
                this.$nextTick(() => {
                    setTimeout(() => {
                        if (!this.skip) {
                            _this.$router.replace('/')
                        }
                    }, 2000)
                })
            }).catch(() => {
                _this.logining = false;
                _this.loginStr = "重新登录";
            });
        },

        /**
         * 初始化粒子背景。参考静态登录页。最后更新：2026-03-29
         */
        initParticleCanvas() {
            const canvas = this.$refs.bgCanvas;
            if (!canvas) return;
            const ctx = canvas.getContext('2d');
            if (!ctx) return;

            const colors = [
                'rgba(12, 184, 201, ',
                'rgba(9, 105, 218, ',
                'rgba(2, 132, 199, ',
                'rgba(245, 130, 32, ',
            ];
            const isTouch = this.isTouchDevice;
            const mouse = this.particleMouse;

            const createParticle = (width, height, init) => {
                const speedScale = isTouch ? 0.35 : 0.5;
                const colorIndex = Math.random() > 0.12 ? Math.floor(Math.random() * 3) : 3;
                return {
                    x: init ? Math.random() * width : (Math.random() > 0.5 ? 0 : width),
                    y: Math.random() * height,
                    size: Math.random() * 2 + 0.8,
                    speedX: (Math.random() - 0.5) * speedScale,
                    speedY: (Math.random() - 0.5) * speedScale,
                    baseColor: colors[colorIndex],
                    alpha: Math.random() * 0.45 + 0.25,
                };
            };

            const resize = () => {
                const dpr = Math.min(window.devicePixelRatio || 1, 2);
                const width = window.innerWidth;
                const height = window.innerHeight;
                canvas.width = width * dpr;
                canvas.height = height * dpr;
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
                ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

                let targetCount = Math.floor((width * height) / 16000);
                if (width < 640) targetCount = Math.min(targetCount, 30);
                else if (width < 1024) targetCount = Math.min(targetCount, 48);
                else targetCount = Math.min(targetCount, 75);

                this.particles = [];
                const count = Math.max(targetCount, 20);
                for (let i = 0; i < count; i++) {
                    this.particles.push(createParticle(width, height, true));
                }
                this._particleSize = { width, height, ctx };
            };

            const connect = (width) => {
                const maxDist = width < 640 ? 90 : 120;
                const list = this.particles;
                for (let a = 0; a < list.length; a++) {
                    for (let b = a + 1; b < list.length; b++) {
                        const dx = list[a].x - list[b].x;
                        const dy = list[a].y - list[b].y;
                        const dist = Math.sqrt(dx * dx + dy * dy);
                        if (dist < maxDist) {
                            const lineAlpha = (1 - dist / maxDist) * (width < 640 ? 0.14 : 0.18);
                            ctx.beginPath();
                            ctx.moveTo(list[a].x, list[a].y);
                            ctx.lineTo(list[b].x, list[b].y);
                            ctx.strokeStyle = `rgba(12, 184, 201, ${lineAlpha})`;
                            ctx.lineWidth = 0.75;
                            ctx.stroke();
                        }
                    }
                }
            };

            const tick = () => {
                if (!this._particleSize) return;
                const { width, height } = this._particleSize;
                ctx.clearRect(0, 0, width, height);
                const list = this.particles;
                for (let i = 0; i < list.length; i++) {
                    const p = list[i];
                    p.x += p.speedX;
                    p.y += p.speedY;
                    if (p.x < 0 || p.x > width) p.speedX *= -1;
                    if (p.y < 0 || p.y > height) p.speedY *= -1;
                    if (!isTouch && mouse.x !== null && mouse.y !== null) {
                        const dx = mouse.x - p.x;
                        const dy = mouse.y - p.y;
                        const dist = Math.sqrt(dx * dx + dy * dy);
                        if (dist < mouse.radius && dist > 0) {
                            const force = (mouse.radius - dist) / mouse.radius;
                            p.x -= (dx / dist) * force * 1.2;
                            p.y -= (dy / dist) * force * 1.2;
                        }
                    }
                    ctx.beginPath();
                    ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
                    ctx.fillStyle = p.baseColor + p.alpha + ')';
                    ctx.fill();
                }
                connect(width);
                this.particleAnimId = requestAnimationFrame(tick);
            };

            this._onParticleResize = () => {
                clearTimeout(this.particleResizeTimer);
                this.particleResizeTimer = setTimeout(resize, 150);
            };
            this._onParticleMove = (e) => {
                mouse.x = e.clientX;
                mouse.y = e.clientY;
            };
            this._onParticleLeave = () => {
                mouse.x = null;
                mouse.y = null;
            };

            resize();
            tick();
            window.addEventListener('resize', this._onParticleResize);
            if (!isTouch) {
                window.addEventListener('mousemove', this._onParticleMove);
                window.addEventListener('mouseleave', this._onParticleLeave);
            }
        },
        destroyParticleCanvas() {
            if (this.particleAnimId) {
                cancelAnimationFrame(this.particleAnimId);
                this.particleAnimId = 0;
            }
            clearTimeout(this.particleResizeTimer);
            if (this._onParticleResize) window.removeEventListener('resize', this._onParticleResize);
            if (this._onParticleMove) window.removeEventListener('mousemove', this._onParticleMove);
            if (this._onParticleLeave) window.removeEventListener('mouseleave', this._onParticleLeave);
        },
    },
    created() {
        // 尽早恢复，避免表单先渲染空值。最后更新：2026-03-29
        this.restoreRememberAccount();
    },
    beforeDestroy() {
        this.skip = true;
        this.destroyParticleCanvas();
        if (this.smsCountdownTimer) {
            clearInterval(this.smsCountdownTimer);
            this.smsCountdownTimer = null;
        }
        if (this.resetCountdownTimer) {
            clearInterval(this.resetCountdownTimer);
            this.resetCountdownTimer = null;
        }
    },
    mounted() {
        console.info('%c 本地缓存已清空!', "color:green")
        this.isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
        // 再回填一次，防止其他初始化逻辑覆盖
        this.restoreRememberAccount();
        this.$nextTick(() => {
            this.restoreRememberAccount();
            const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (!reduceMotion) {
                this.initParticleCanvas();
            }
        });

        this.$store.commit('setDepartmentName', '')
        window.localStorage.removeItem('schoolList');
        window.localStorage.removeItem('activeSchoolId');
        window.localStorage.removeItem('activeSchoolName');
        clearDeptTreeCache();
        this.$root.$emit('clear-school-context');
        getSmsLoginOptions().then((data) => {
            const response = data && data.success ? data.response : null;
            this.smsLoginEnabled = !!(response && response.smsLoginEnabled);
            this.passwordResetEnabled = !!(response && response.passwordResetEnabled);
        }).catch(() => {
            this.smsLoginEnabled = false;
            this.passwordResetEnabled = false;
        });
    },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Noto+Sans+SC:wght@400;500;700;900&display=swap');

.yiqi-login {
    --brand-cyan: #0cb8c9;
    --brand-sky: #0284c7;
    --brand-blue: #0969da;
    --brand-deep: #033b82;
    --brand-dark: #07182e;
    --brand-orange: #f58220;
    position: relative;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    overflow-x: hidden;
    background: #051326;
    color: #1e293b;
    font-family: 'Plus Jakarta Sans', 'Noto Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
    -webkit-font-smoothing: antialiased;
}

@media (min-width: 640px) {
    .yiqi-login {
        padding: 24px;
    }
}

@media (min-width: 1024px) {
    .yiqi-login {
        padding: 32px;
    }
}

.yiqi-login__blobs {
    position: fixed;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;
}

.yiqi-blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(100px);
    opacity: 0.75;
    animation: yiqi-blob 18s infinite alternate cubic-bezier(0.4, 0, 0.2, 1);
}

.yiqi-blob--a {
    top: -15%;
    left: -10%;
    width: 50vw;
    height: 50vw;
    background: linear-gradient(to top right, rgba(3, 59, 130, 0.6), rgba(12, 184, 201, 0.3));
}

.yiqi-blob--b {
    top: 35%;
    right: -15%;
    width: 45vw;
    height: 45vw;
    background: linear-gradient(to bottom right, rgba(9, 105, 218, 0.5), rgba(245, 130, 32, 0.2));
    animation-name: yiqi-blob-slow;
    animation-duration: 24s;
    animation-direction: alternate-reverse;
}

.yiqi-blob--c {
    bottom: -20%;
    left: 15%;
    width: 40vw;
    height: 40vw;
    background: linear-gradient(to top, rgba(2, 68, 134, 0.6), rgba(12, 184, 201, 0.25));
    opacity: 0.6;
}

.yiqi-login__canvas {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
}

.yiqi-card {
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1024px;
    margin: auto;
    overflow: hidden;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(28px);
    -webkit-backdrop-filter: blur(28px);
    box-shadow:
        0 24px 60px -15px rgba(3, 27, 58, 0.35),
        0 0 0 1px rgba(255, 255, 255, 0.9) inset;
}

@media (min-width: 640px) {
    .yiqi-card {
        border-radius: 24px;
    }
}

@media (min-width: 768px) {
    .yiqi-card {
        flex-direction: row;
        min-height: 560px;
    }
}

/* 左侧品牌：底图已完美内嵌发光立体Logo；文案现代精致排版。最后更新：2026-10-30 */
.yiqi-brand {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 320px;
    padding: 0;
    overflow: hidden;
    background: #d7ecff;
    border-bottom: 1px solid rgba(148, 163, 184, 0.16);
    flex-shrink: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
}

@media (min-width: 768px) {
    .yiqi-brand {
        width: 42%;
        min-height: 0;
        border-bottom: 0;
        border-right: 1px solid rgba(148, 163, 184, 0.12);
    }
}

/* 左侧背景底图：通过微调垂直偏移（8px ~ 12px），把偏上的内容向下压回中心 */
.yiqi-brand__bg {
    position: absolute;
    /* 上左右贴边，底部向下多延伸 20px，保证下移后底部依然被背景完全填满 */
    top: 0;
    left: 0;
    right: 0;
    bottom: -20px;
    /* 配合使用 center top 或带微调的偏移，背景就不会在底部截断 */
    background: url('../assets/login-brand-bg.jpg') center top / cover no-repeat;
}

/* ==================== 左侧品牌区域优化 ==================== */

.yiqi-brand__content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 0;
    /* 增加底部内边距，给下方建筑预留视觉留白 */
    padding: 0 24px 36px;
    box-sizing: border-box;
    /* 让内容在垂直方向更合理地舒展 */
    justify-content: flex-start;
}

/* 顶部光球占位区域：配合背景下沉，微调文字上边距，防止文字与球体底部贴靠 */
.yiqi-brand__orb-space {
    width: 100%;
    height: 220px;
    flex-shrink: 0;
}

@media (min-width: 768px) {
    .yiqi-brand {
        /* 原来是 42%，调整为 48% 或 50% */
        width: 48%;
        min-height: 0;
        border-bottom: 0;
        border-right: 1px solid rgba(148, 163, 184, 0.12);
    }

    .yiqi-brand__orb-space {
        height: 46%;
        min-height: 255px;
        max-height: 295px;
    }
}

@media (min-width: 1024px) {
    .yiqi-brand__orb-space {
        height: 48%;
        min-height: 275px;
        max-height: 315px;
    }
}

/* 2. 品牌文案区：拉开呼吸感 */
.yiqi-brand__hero {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 340px;
    text-align: center;
    margin-top: 0;
    /* 移除负 margin */
}

/* 主标题：增大字号与字间距 */
.yiqi-brand__title {
    margin: 0;
    font-size: 24px;
    font-weight: 800;
    line-height: 1.4;
    letter-spacing: 0.12em;
    color: #07477a;
    text-shadow:
        0 0 16px rgba(255, 255, 255, 0.95),
        0 1px 3px rgba(255, 255, 255, 0.9);
}

@media (min-width: 1024px) {
    .yiqi-brand__title {
        font-size: 27px;
    }
}

/* 副标语：与标题拉开间距，稍微加粗提亮 */
.yiqi-brand__slogan {
    margin: 12px 0 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5;
    letter-spacing: 0.18em;
    color: #0284c7;
    text-shadow: 0 0 12px rgba(255, 255, 255, 0.95);
}

/* 辅助说明段落：微调字号和行高，避免两行挤作一团 */
.yiqi-brand__desc {
    margin: 12px 0 0;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.75;
    letter-spacing: 0.04em;
    color: #334155;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.95);
}

/* 3. 标签胶囊区：拉开与上方描述文本的距离 */
.yiqi-brand__badges {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-top: 20px;
    flex-wrap: wrap;
}

.yiqi-brand__badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 9999px;
    background: rgba(255, 255, 255, 0.88);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(14, 165, 233, 0.28);
    box-shadow: 0 2px 8px rgba(9, 105, 218, 0.08);
    color: #0369a1;
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: 0.04em;
    line-height: 1;
    user-select: none;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.yiqi-brand__badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(9, 105, 218, 0.14);
}

.yiqi-brand__badge i {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #0284c7;
    color: #ffffff;
    font-size: 10px;
    font-weight: bold;
}

/* 右侧表单 */
.yiqi-panel {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 24px;
    background: rgba(255, 255, 255, 0.9);
}

@media (min-width: 640px) {
    .yiqi-panel {
        padding: 40px;
    }
}

@media (min-width: 768px) {
    .yiqi-panel {
        width: 52%;
    }
}

@media (min-width: 1024px) {
    .yiqi-panel {
        padding: 56px;
    }
}

.yiqi-panel__inner {
    width: 100%;
    max-width: 24rem;
    margin: 0 auto;
}

.yiqi-panel__head {
    margin-bottom: 24px;
    text-align: center;
}

@media (min-width: 640px) {
    .yiqi-panel__head {
        margin-bottom: 32px;
    }
}

@media (min-width: 768px) {
    .yiqi-panel__head {
        text-align: left;
    }
}

.yiqi-panel__head h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: #0f172a;
}

@media (min-width: 640px) {
    .yiqi-panel__head h1 {
        font-size: 30px;
    }
}

.yiqi-panel__head p {
    margin: 6px 0 0;
    min-height: 42px;
    font-size: 12px;
    line-height: 1.5;
    color: #64748b;
}

.yiqi-login-tabs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4px;
    padding: 4px;
    margin: 0 0 22px;
    height: 48px;
    box-sizing: border-box;
    border-radius: 12px;
    background: #f1f5f9;
}

.yiqi-login-tabs button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 40px;
    margin: 0;
    padding: 0 10px;
    border: 1px solid transparent;
    border-radius: 9px;
    background: transparent;
    color: #64748b;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    box-sizing: border-box;
    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.yiqi-login-tabs button i {
    margin: 0;
    font-size: 14px;
    line-height: 1;
}

.yiqi-login-tabs button span {
    line-height: 1;
    white-space: nowrap;
}

.yiqi-login-tabs button.active {
    background: #fff;
    color: var(--brand-blue);
    border-color: #dbeafe;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.yiqi-form {
    min-height: 268px;
}

.yiqi-sms-code {
    display: flex;
    align-items: stretch;
    gap: 10px;
}

.yiqi-sms-code .yiqi-input {
    flex: 1;
    min-width: 0;
}

.yiqi-sms-code__button {
    flex: 0 0 auto;
    min-width: 118px;
    height: 48px !important;
    padding: 0 12px !important;
    border-radius: 12px !important;
    color: var(--brand-blue);
    background: #eff6ff;
    border-color: #bfdbfe;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
}

.yiqi-sms-code__button:hover,
.yiqi-sms-code__button:focus {
    color: #fff;
    background: var(--brand-blue);
    border-color: var(--brand-blue);
}

.yiqi-form__remember--spacer {
    height: 22px;
    margin: 2px 0 8px;
    visibility: hidden;
    pointer-events: none;
}

@media (min-width: 640px) {
    .yiqi-panel__head p {
        font-size: 14px;
    }
}

.yiqi-form>>>.el-form-item {
    margin-bottom: 18px;
}

.yiqi-form>>>.el-form-item__label {
    padding: 0 0 8px !important;
    line-height: 1.2;
    float: none !important;
    display: flex !important;
    align-items: center;
    justify-content: flex-start;
    width: 100% !important;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #334155;
}

/* 必填红星与文字同一行 */
.yiqi-form>>>.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label::before {
    display: inline-block;
    flex-shrink: 0;
    margin-right: 4px;
    line-height: 1.2;
}

.yiqi-form__pwd-label {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #334155;
}

.yiqi-form__forgot {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
    color: var(--brand-blue);
    text-decoration: none;
}

.yiqi-form__forgot:hover {
    color: var(--brand-deep);
}

.yiqi-form>>>.el-input__inner {
    height: 48px;
    line-height: 48px;
    padding-left: 40px;
    border-radius: 12px;
    border-color: #e2e8f0;
    background: rgba(248, 250, 252, 0.9);
    font-size: 16px;
    color: #0f172a;
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.yiqi-form>>>.el-input__inner:focus {
    border-color: var(--brand-blue);
    background: #fff;
    box-shadow: 0 0 0 4px rgba(9, 105, 218, 0.1);
}

.yiqi-form>>>.el-input__prefix {
    left: 10px;
    color: #94a3b8;
}

.yiqi-form__remember {
    display: flex;
    align-items: center;
    margin: 2px 0 8px;
    min-height: 22px;
}

.yiqi-form__remember>>>.el-checkbox__label {
    font-size: 12px;
    color: #475569;
    font-weight: 500;
}

.yiqi-form__remember>>>.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--brand-blue);
    border-color: var(--brand-blue);
}

.yiqi-form__action {
    margin-bottom: 0 !important;
    margin-top: 12px;
}

.yiqi-form__submit {
    position: relative;
    width: 100%;
    min-height: 48px;
    height: 48px;
    border: none;
    border-radius: 12px;
    background: linear-gradient(90deg, var(--brand-blue), #0557bd, var(--brand-deep));
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.12em;
    box-shadow: 0 10px 24px rgba(9, 105, 218, 0.25);
    overflow: hidden;
    transition: filter 0.2s ease, transform 0.15s ease;
}

.yiqi-form__submit:hover,
.yiqi-form__submit:focus {
    background: linear-gradient(90deg, #085ac0, #02316e);
    filter: brightness(1.03);
}

.yiqi-form__submit:active {
    transform: scale(0.98);
}

.yiqi-form>>>.el-button.is-disabled,
.yiqi-form>>>.el-button.is-disabled:hover {
    background: linear-gradient(90deg, #7aa8e8, #5b7fb8);
    opacity: 0.85;
}

.yiqi-panel__foot {
    margin-top: 32px;
    padding-top: 16px;
    border-top: 1px solid #f1f5f9;
    text-align: center;
    font-size: 11px;
    color: #94a3b8;
    line-height: 1.6;
}

.yiqi-panel__foot p {
    margin: 0;
}

.yiqi-reset-back {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin: 0 0 8px;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--brand-blue);
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
}

.yiqi-reset-back:hover {
    text-decoration: underline;
}

.yiqi-reset-feedback {
    margin: 0 0 4px;
    padding: 10px 12px;
    border-radius: 10px;
    font-size: 12px;
    line-height: 1.5;
}

.yiqi-reset-feedback.success {
    background: #ecfdf5;
    color: #047857;
}

.yiqi-reset-feedback.error {
    background: #fef2f2;
    color: #b91c1c;
}

@media (min-width: 640px) {
    .yiqi-panel__foot {
        margin-top: 40px;
        padding-top: 24px;
    }
}

@keyframes yiqi-blob {
    0% {
        transform: translate(0, 0) scale(1);
    }

    33% {
        transform: translate(30px, -45px) scale(1.1);
    }

    66% {
        transform: translate(-25px, 25px) scale(0.95);
    }

    100% {
        transform: translate(0, 0) scale(1);
    }
}

@keyframes yiqi-blob-slow {
    0% {
        transform: translate(0, 0) scale(1);
    }

    33% {
        transform: translate(-20px, 30px) scale(1.05);
    }

    66% {
        transform: translate(25px, -20px) scale(0.97);
    }

    100% {
        transform: translate(0, 0) scale(1);
    }
}

@media (prefers-reduced-motion: reduce) {
    .yiqi-blob {
        animation: none !important;
    }
}
</style>
